import useSWR from "swr";
import fetcher from "./fetcher";

export const shopOpenNoticeKey = (influencerId) =>
  influencerId ? `/api/influencer/${influencerId}/shopOpenNotice` : null;

export function useShopOpenNotice(influencerId) {
  const { data, error, mutate } = useSWR(
    shopOpenNoticeKey(influencerId),
    fetcher,
  );

  return {
    visible: Boolean(data?.visible),
    recipientCount: data?.recipientCount,
    optedOutCount: data?.optedOutCount,
    recentlyNotifiedCount: data?.recentlyNotifiedCount,
    isLoading: !data && !error,
    isError: Boolean(error),
    refresh: mutate,
  };
}

export default useShopOpenNotice;
